<template>
    <div class="header header-bg-lg header-bg-shape border-bottom-1">
        <div class="container-fluid p-lg-0">
            <div class="row m-lg-0">
                <div class="col-lg-12 p-lg-0">
                    <div class="max-800 mx-auto text-center">
                        <div class="header-content">
                            <h1 :class="['main-title', { 'main-title-en': isEnglishLocale }]">
                                <span class="title-part-1">{{ $t('home.hero.titlePart1') }}</span>
                                <span class="title-line-2">
                                    <span class="title-part-2">{{ $t('home.hero.titlePart2') }}</span>
                                    <span class="title-part-3">{{ $t('home.hero.titlePart3') }}</span>
                                </span>
                            </h1>
                            <p class="subtitle">{{ $t('home.hero.subtitle') }}</p>
                            <div class="button-group button-group-animated">
                                <router-link to="/services" class="btn explore-btn">
                                    {{ $t('home.hero.buttons.explore') }}
                                </router-link>
                                <router-link to="/contact" class="btn contact-btn">
                                    {{ $t('home.hero.buttons.contact') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainBanner',
    computed: {
        isEnglishLocale() {
            if (this.$y18n && this.$y18n.locale) {
                return this.$y18n.locale.value === 'en'
            }
            return typeof this.$getLang === 'function' ? this.$getLang() === 'en' : false
        }
    }
}
</script>

<style scoped>
.header {
    min-height: 600px;
    position: relative;
    display: flex;
    align-items: center;
}

/* Main title styles */
.main-title {
    font-size: 110px;
    font-weight: 800;
    margin-bottom: 2rem;
    line-height: 1.5;
    letter-spacing: -0.02em;
}
.main-title-en {
    font-size: 80px;
    font-weight: 700;
}

.title-part-1 {
    color: #000;
    display: inline;
    margin-right: 0.5em;
    white-space: nowrap;
}

.title-part-2 {
    background: linear-gradient(90deg, #3B57FD 0%, #AB39E9 50%, #FF2E88 73.08%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: "Microsoft YaHei";
    font-style: normal;
    font-weight: 700;
    line-height: 108%;
    display: inline;
}

.title-part-3 {
    color: #000;
    display: inline;
    margin-left: 0.1em;
}

/* Keep the second line together when wrapping */
.title-line-2 {
    display: inline;
}

/* Subtitle styles */
.subtitle {
    font-size: 24px;
    color: #767676;
    margin-bottom: 3rem;
    line-height: 1.6;
    /* max-width: 700px; */
    margin-left: auto;
    margin-right: auto;
    font-weight: 400;
}

/* Button group */
.button-group {
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    flex-wrap: wrap;
}

/* Explore more button */
.explore-btn {
    background: white;
    color: #000;
    border: none;
    border-radius: 34.5px;
    width: 297.605px;
    height: 69px;
    padding: 18px 59px;
    font-weight: 700;
    font-size: 1rem;
    transition: all 0.3s ease;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    box-shadow: 0 4px 16.6px 0 rgba(122, 151, 177, 0.25);
}

.explore-btn:hover {
    background: #0B71FA;
    color: white;
    border: none;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(11, 113, 250, 0.3);
    text-decoration: none;
}

/* Contact us button */
.contact-btn {
    background: #3A7BFD;
    color: white;
    border: none;
    border-radius: 34.5px;
    width: 297.605px;
    height: 69px;
    padding: 18px 59px;
    font-weight: 700;
    font-size: 1rem;
    transition: all 0.3s ease;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    box-shadow: 0 4px 5.8px 0 rgba(72, 134, 193, 0.15);
}

.contact-btn:hover {
    background: linear-gradient(90deg, #0B71FA 0%, #FF94C8 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 148, 200, 0.3);
    text-decoration: none;
    color: white;
}

/* Decorative elements */
.decorative-elements {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
}

/* Stars in the top-left corner */
.stars-top-left {
    position: absolute;
    top: 80px;
    left: 80px;
    display: flex;
    gap: 8px;
}

.star {
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    position: relative;
}

.star-blue {
    background: #0B71FA;
}

.star-pink {
    background: #FF94C8;
}

.star-small {
    width: 12px;
    height: 12px;
}

/* Lightning bolt bottom right */
.lightning-bottom-right {
    position: absolute;
    bottom: 80px;
    right: 80px;
}

.lightning-icon {
    width: 30px;
    height: 30px;
    background: #0B71FA;
    clip-path: polygon(50% 0%, 0% 100%, 30% 100%, 50% 60%, 70% 100%, 100% 100%);
}

/* Center glow at the bottom */
.sparkle-bottom-center {
    position: absolute;
    bottom: 120px;
    left: 50%;
    transform: translateX(-50%);
}

.sparkle {
    width: 16px;
    height: 16px;
    background: white;
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    opacity: 0.7;
}

/* Responsive design */
@media (max-width: 768px) {
    .main-title {
        font-size: 2.8rem;
    }

    /* Force the title to wrap on small screens */
    .title-part-1 {
        display: block;
        margin-right: 0;
    }

    .title-line-2 {
        display: block;
        white-space: nowrap;
    }
    .subtitle {
        font-size: 24px;
        padding: 0 20px;
        margin-bottom: 2.5rem;
    }
    
    .button-group {
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }
    
    .explore-btn,
    .contact-btn {
        width: 280px;
        height: 60px;
        padding: 16px 50px;
    }
    
    .stars-top-left {
        top: 40px;
        left: 40px;
    }
    
    .lightning-bottom-right {
        bottom: 40px;
        right: 40px;
    }
    
    .sparkle-bottom-center {
        bottom: 80px;
    }
}
</style>
